package com.isaias.fyattravel.web.layout
 
import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import com.isaias.fyattravel.web.i18n.WebLocale
import com.isaias.fyattravel.web.i18n.WebLocaleStore
import com.isaias.fyattravel.web.i18n.WebStringKey
import com.isaias.fyattravel.web.i18n.WebStrings
import com.isaias.fyattravel.web.theme.ThemeColors
 
@Composable
fun LanguageFab() {
    var isOpen by remember { mutableStateOf(false) }
    val currentLocale = WebLocaleStore.locale.value
    val isRtl = WebLocaleStore.isRtl(currentLocale)
    val openLabel = WebStrings.t(WebStringKey.OPEN_LANGUAGE)
 
    Div({
        style {
            position(Position.Fixed)
            bottom(24.px)
            right(24.px)
            property("z-index", "999")
        }
    }) {
        if (isOpen) {
            Div({
                style {
                    position(Position.Absolute)
                    bottom(64.px)
                    right(0.px)
                    width(240.px)
                    backgroundColor(ThemeColors.surface)
                    borderRadius(16.px)
                    padding(0.75.em)
                    property("box-shadow", "0 16px 32px rgba(0,0,0,0.16)")
                    property("border", "1px solid ${ThemeColors.divider}")
                    property("text-align", if (isRtl) "right" else "left")
                }
            }) {
                Div({
                    style {
                        fontWeight("800")
                        color(ThemeColors.textPrimary)
                        marginBottom(0.5.em)
                    }
                }) { Text(WebStrings.t(WebStringKey.LANGUAGE)) }
 
                WebLocale.values().forEach { locale ->
                    val isSelected = locale == currentLocale
                    Div({
                        style {
                            display(DisplayStyle.Flex)
                            justifyContent(JustifyContent.SpaceBetween)
                            alignItems(AlignItems.Center)
                            padding(0.6.em)
                            borderRadius(10.px)
                            backgroundColor(if (isSelected) ThemeColors.primaryMuted else Color.transparent)
                            color(if (isSelected) ThemeColors.primary else ThemeColors.textMuted)
                            fontWeight(if (isSelected) "700" else "500")
                            cursor("pointer")
                        }
                        onClick {
                            WebLocaleStore.setLocale(locale)
                            isOpen = false
                        }
                    }) {
                        Div { Text("${locale.nativeName} (${locale.displayName})") }
                        if (isSelected) {
                            Span {
                                Text("✓")
                            }
                        }
                    }
                }
 

            }
        }
 
        Button(attrs = {
            style {
                width(52.px)
                height(52.px)
                borderRadius(18.px)
                backgroundColor(ThemeColors.primary)
                color(ThemeColors.textPrimary)
                property("border", "none")
                property("box-shadow", "0 12px 24px rgba(37,99,235,0.35)")
                cursor("pointer")
                fontSize(22.px)
            }
            onClick { isOpen = !isOpen }
            attr("aria-label", openLabel)
        }) {
            Span({
                ref { el ->
                    el.innerHTML = """
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <circle cx="12" cy="12" r="9"></circle>
                            <path d="M3 12h18"></path>
                            <path d="M12 3a15 15 0 0 1 0 18"></path>
                            <path d="M12 3a15 15 0 0 0 0 18"></path>
                        </svg>
                    """
                    onDispose {}
                }
            })
        }
    }
}
